import { SET_VEHICLE } from './actionTypes'
import { VehicleActionTypes } from './types'

const initialState = {
  auststate: '',
  kms: '', 
  rego: '', 
  // conditions: {}, 
  redbookcode: '', 
  badge: '', 
  badge2nd: '',

  rbid: "",
  makecode: "",
  familycode: "",
  vehicletype: "",
  year: "",
  month: "",
  sequenceno: "",
  description: "",
  newvehicleflag: "",
  importflag: "",
  limitededition: "",
  series: "",
  bodystyle: "",
  drive: "",
  geartype: "",
  gearlocation: "",
  gearnum: "",
  doornum: "",
  enginesize: "",
  enginedesc: "",
  cylinders: "",
  fueltype: "",
  induction: "",
  cam: "",
  enginetype: "",
  fuelcapacity: "",
  fueldelivery: "",
  methoddelivery: "",
  gvm: "",
  wheelbase: "",
  height: "",
  length: "",
  width: "",
  kerbweight: "",
  taremass: "",
  power: "",
  powerrpmto: "",
  torque: "",
  torquerpmfrom: "",
  torquerpmto: "",
  seatcapacity: "",
  avgkm: "",
  gdkm: "",
  newprice: "",
  make: "",
  family: "",
  isBestMatch: false,
  imageUrl: "",
  matchDebug: {}, 
}

export default (state = initialState, action: VehicleActionTypes) => {
  switch (action.type) {
    case SET_VEHICLE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
